import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../context/LoaderContext";
import {TranslateContext} from "../../context/TranslateContext";
import LabelErroreCampo from "../../components/LabelErroreCampo";
import Translate from "../../components/Translate";
import NsDatePicker from "../../components/NsDatePicker";
import {convertiTimestampInDataPerDb, getAnno, handleMoneyChange} from "../../utility/common";
import NsFormikScrollToError from "../../components/NsFormikScrollToError";
import NSSelectAutocomplete from "../../components/NSSelectAutocomplete";
import NsBtnBack from "../../components/buttons/NsBtnBack";
import {getCausaliMovimentoApi, getContiApi} from "../../services/MovimentiServices";
import {getModalitaPagamentoApi, getQuotaByIdApi} from "../../services/QuoteServices";
import {aggiornaQuotaUtenteApi, aggiungiQuotaUtenteApi} from "../../services/UtentiServices";

function ModificaQuota() {
    const {idUsr, idQuota} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [optionsModalita, setOptionsModalita] = useState([]);
    const [optionsConti, setOptionsConti] = useState([]);
    const [causali, setCausali] = useState([]);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getConti() {
        startChiamata();
        const response = await getContiApi();
        setOptionsConti(response.data.data);
        endChiamata();
    }

    async function getQuota() {
        startChiamata();
        const response = await getQuotaByIdApi(idQuota);
        let val = response.data.data;
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_quota", val.id_quota)
            formikRef.current.setFieldValue("id_utente", idUsr)
            formikRef.current.setFieldValue("data_pagamento", val.data_pagamento)
            formikRef.current.setFieldValue("anno_validita", val.anno_validita)
            formikRef.current.setFieldValue("importo", val.importo)
            formikRef.current.setFieldValue("id_modalita", val.id_modalita)
            formikRef.current.setFieldValue("id_conto", val.id_conto)
            formikRef.current.setFieldValue("note", val.note)
            formikRef.current.setFieldValue("lrid", val.lrid)
            formikRef.current.setFieldValue("canc", val.canc)
            formikRef.current.setFieldValue("id_causale_movimento", val.id_causale_movimento)
        }
        endChiamata();
    }

    async function getModalitaPagamento() {
        startChiamata()
        const response = await getModalitaPagamentoApi();
        setOptionsModalita(response.data.data)
        endChiamata();
    }

    async function getCusali() {
        startChiamata();
        const response = await getCausaliMovimentoApi({
            id_categoria_causale: 'ISCRIZ'
        })
        setCausali(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (loadingData) {
            getModalitaPagamento();
            getCusali();
            getConti();

            if (idQuota && idQuota !== '') {
                getQuota();
            }
        }
    }, [idQuota, idUsr]);

    const SignupSchema = Yup.object().shape({
        data_pagamento: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        anno_validita: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        importo: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        id_modalita: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        id_causale_movimento: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    async function aggiornaQuota(newQuota) {
        startChiamata()
        const response = await aggiornaQuotaUtenteApi(idUsr, idQuota, newQuota);
        if (response.data.result === 0) {
            endChiamata()
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
            endChiamata()
        }
    }

    async function aggiungiQuota(newQuota) {
        startChiamata()
        const response = await aggiungiQuotaUtenteApi(idUsr, newQuota);
        if (response.data.result === 0) {
            endChiamata()
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
            endChiamata()
        }
    }

    function salvaQuota(values) {
        let newQuota = values;
        newQuota['data_pagamento'] = convertiTimestampInDataPerDb(newQuota['data_pagamento'])

        if (idQuota) {
            aggiornaQuota(newQuota);
        } else {
            aggiungiQuota(newQuota);
        }
    }

    return (
        <Card
            icon={'fas fa-credit-card'}
            title={idQuota ? 'Modifica Quota' : 'Inserisci Quota'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_quota: '',
                    id_utente: '',
                    data_pagamento: new Date(),
                    anno_validita: getAnno(new Date()),
                    importo: '',
                    id_modalita: '',
                    note: '',
                    lrid: '',
                    canc: '0',
                    id_causale_movimento: '',
                    id_conto: ''
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={salvaQuota}
            >
                {({errors, touched, values, submitCount}) => (
                    <Form className="row g-3">
                        {
                            idQuota ?
                                <div className="col-md-12">
                                    <label htmlFor="id_quota" className="form-label">Numero registrazione:</label>
                                    <Field
                                        name="id_quota"
                                        className="form-control rfi-number-no-arrows"
                                        type={"number"}
                                        readOnly={true}
                                        onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                                    />
                                    <LabelErroreCampo errors={errors} touched={touched} name={"id_quota"}
                                                      submitCount={submitCount}/>
                                </div>
                                : ''
                        }
                        <div className="col-md-6">
                            <label htmlFor="data_pagamento" className="form-label"><Translate>Data
                                pagamento*</Translate>:</label>
                            <NsDatePicker
                                nome={"data_pagamento"}
                                dataSelezionata={values["data_pagamento"]}
                                maxDate={new Date()}
                                setSelectedDate={(date, event) => {
                                    formikRef.current.setFieldValue("data_pagamento", date)
                                }}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"data_pagamento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="anno_validita" className="form-label">Anno di validità*:</label>
                            <Field
                                name="anno_validita"
                                className="form-control rfi-number-no-arrows"
                                type={"number"}
                                onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"anno_validita"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="importo" className="form-label">Importo pagato*:</label>
                            <Field
                                name="importo"
                                className="form-control rfi-number-no-arrows"
                                type={"number"}
                                step="0.01"
                                onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                                onKeyDown={(e) => {
                                    handleMoneyChange(e)
                                }}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"importo"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_modalita" className="form-label">Modalità di pagamento*:</label>
                            <Field as="select" name="id_modalita" className={'form-select'}>
                                <option value={""}>Selezionare una modalità</option>
                                {
                                    optionsModalita.map((op, index) => {
                                        return <option key={index} value={op.id_modalita}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_modalita"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_causale_movimento" className="form-label">Causale pagamento*:</label>
                            <NSSelectAutocomplete
                                name={"id_causale_movimento"}
                                formikRef={formikRef}
                                options={causali ? causali.map(cau => {
                                    return {
                                        label: cau.descrizione + ' - [' + cau.id_causale_movimento + ']',
                                        value: cau.id_causale_movimento,
                                    };
                                }) : []}
                                startVal={values["id_causale_movimento"]}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_causale_movimento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="id_conto" className="form-label">Conto:</label>
                            <Field as="select" name="id_conto" className={'form-select'}>
                                <option value={""}>Selezionare un conto</option>
                                {
                                    optionsConti.map((op, index) => {
                                        return <option key={index} value={op.id_conto}>{op.descrizione}</option>
                                    })
                                }
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_conto"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="note" className="form-label">Note sul pagamento:</label>
                            <Field
                                as="textarea"
                                name="note"
                                className={'form-select'}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"note"}
                                              submitCount={submitCount}/>
                        </div>
                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}

export default ModificaQuota;